
import sirepAPI from "@/api/sirepApi";
import sirepApiFiles from "@/api/sirepApiFiles"

export const getSection = async ({commit}, id_recinto) => {
    try {
        const { data } = await sirepAPI.get("/visitas/lista_secciones/"+ id_recinto)
        return {data}         
    } catch (error) {
        return {message:error}
    }
}
export const getDataVisit = async ({ commit }, { data, type }) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const ci_usuario = userData.nro_documento;

    let payload = {};

    if (type === "complete" && data && data.token) {
      payload = {
        token: data.token,
        ci_usuario,
        type,
      };
    } else {
      const nro_documento = data && data.nro_documento ? data.nro_documento : "";
      const complemento =
        data && data.complemento !== "" && data.complemento !== null
          ? data.complemento
          : "0";
      const tipo_documento =
        data && data.tipo_documento ? data.tipo_documento : "";

      payload = {
        nro_documento,
        complemento,
        tipo_documento,
        ci_usuario,
        type,
      };
    }

    const response = await sirepAPI.post(
      "/visitas/buscar_persona_visita",
      payload
    );

    return {
      data: response.data,
    };
  } catch (error) {
    console.error("Error getDataVisit:", error);

    return {
      data: {
        ok: false,
        respuesta:
          error &&
          error.response &&
          error.response.data &&
          error.response.data.respuesta
            ? error.response.data.respuesta
            : error &&
              error.response &&
              error.response.data &&
              error.response.data.message
              ? error.response.data.message
              : "Error consultando datos de visita",
      },
    };
  }
};
export const valueToSearch = async({commit}, value) => {
    try {
        let id_recinto = JSON.parse(localStorage.getItem('user')).cod_recinto_penitenciario;
        let departamento = JSON.parse(localStorage.getItem('user')).departamento_supervisar;
        departamento===null?departamento=0:departamento;
        id_recinto===null?id_recinto=0:id_recinto;
        const {data} = await sirepAPI.post("/visitas/buscar_ppl/"+ id_recinto + "/" + departamento, {value})
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const valueToSearchVisit = async({commit}, value) => {
    try {
        let id_recinto = JSON.parse(localStorage.getItem('user')).cod_recinto_penitenciario;
        let departamento = JSON.parse(localStorage.getItem('user')).departamento_supervisar;
        departamento===null?departamento=0:departamento;
        id_recinto===null?id_recinto=0:id_recinto;
        const {data} = await sirepAPI.post("/visitas/buscar_visitante/"+ id_recinto + "/" + departamento, value)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const register = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/visitas/registrar_visita/"+nro_documento,{value})
        return {data}
    } catch (error) {
        return {message:error}
    }
} 
export const visitsList = async({commit},tipo) => {
    try {
        let id_recinto = JSON.parse(localStorage.getItem('user')).cod_recinto_penitenciario
        let departamento = JSON.parse(localStorage.getItem('user')).departamento_supervisar;
        departamento===null?departamento=0:departamento;
        id_recinto===null?id_recinto=0:id_recinto;
        const {data} = await sirepAPI.get("/visitas/lista_visitas/"+ tipo + "/"+ id_recinto + "/" + departamento)
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const visitDetails = async({commit},id) => {
    try {
        const {data} = await sirepAPI.get("/visitas/detalles_visita/"+ id )
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const CheckOutVisit = async({commit},value) => {
    try { 
        let{id_persona_visita, observacion}= value;
        const {data} = await sirepAPI.patch("/visitas/registrar_salida_visita/" + id_persona_visita.value, {observacion: observacion.value})
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const saveImage = async({commit}, val) =>{
    let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
    const {img, id_persona_visita} =  val
    const formData = new FormData();
        formData.append('uploaded_image', img);
    try {
         var ext = img.name.split('.').pop();
        if(ext!=='png' && ext!=='jpg' && ext!=='jpeg'){
                    alert("error")
                    return false
                  }
        const {data} = await sirepApiFiles.post("/visitas/upload_image/"+ userLogged + '/' + id_persona_visita, formData)
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const seeImagesfromBack = async({commit}, id_img_visita) => {
    try {
        const response =  await sirepAPI.get("/visitas/view_img/"+id_img_visita, {responseType:'blob'})
        const urlCreator = window.URL || window.webkitURL;
        const imageUrl = urlCreator.createObjectURL(response.data);
        return imageUrl;
    } catch (error) {
        return {message:error}
    }
}
export const deleteImageFromBack = async({commit},id) => {
    try {
        const {data} = await sirepAPI.get("/visitas/delete_img/"+ id )
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const checkRestriction = async({commit},value) => {
    const {id_recinto, nro_documento, complemento}=value;
    try {
        const {data} = await sirepAPI.get("/visitas/verificar_restriccion_por_numero_documento/"+id_recinto+'/'+ nro_documento+'/'+ complemento)
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const normativeList = async() => {
    try {
        const {data} = await sirepAPI.get("/visitas/obtener_normas")
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const registerRestriction = async ({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/visitas/registrar_restriccion/"+nro_documento, value)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const restrictionsList = async({commit},tipo) => {
    try {
        let id_recinto = JSON.parse(localStorage.getItem('user')).cod_recinto_penitenciario
        let departamento = JSON.parse(localStorage.getItem('user')).departamento_supervisar;
        departamento===null?departamento=0:departamento;
        id_recinto===null?id_recinto=0:id_recinto;
        const {data} = await sirepAPI.get("/visitas/lista_restricciones/"+ tipo + "/"+ id_recinto + "/" + departamento)
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const uploadFile = async({commit}, id) =>{
    const formData = new FormData();
        formData.append('uploaded_file', id[0]);
    try {
        var ext = id[0].name.split('.').pop();
                if(ext!=='pdf' && ext!=='PDF'){
                    alert("error")
                    return false
                  }
        //let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepApiFiles.post("/visitas/subir_archivo_restriccion/"+ id[1], formData)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const uploadFileLiftRestriction = async({commit}, id) =>{
    const formData = new FormData();
        formData.append('uploaded_file', id[0]);
    try {
        var ext = id[0].name.split('.').pop();
                if(ext!=='pdf' && ext!=='PDF'){
                    alert("error")
                    return false
                  }
        //let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepApiFiles.post("/visitas/subir_archivo_levantamiento_restriccion/"+ id[1], formData)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const viewFile = ({commit}, id) => {
    try {
        //const resp =  open("http://localhost:3012/visitas/ver_archivo_restriccion/"+id)
        const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/visitas/ver_archivo_restriccion/"+id)
        return resp
    } catch (error) {
        return {message:error}
    }
}
export const viewFileLiftRestriction = ({commit}, id) => {
    try {
        //const resp =  open("http://localhost:3012/visitas/ver_archivo_levantamiento_restriccion/"+id)
        const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/visitas/ver_archivo_levantamiento_restriccion/"+id)
        return resp
    } catch (error) {
        return {message:error}
    }
}
export const deleteFile = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/visitas/eliminar_archivo_restriccion/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const deleteFileLiftRestriction = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/visitas/eliminar_archivo_levantamiento_restriccion/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const liftRestriction = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/visitas/levantar_restriccion/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const registerLiftRestriction = async({commit}, values) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const { data } = await sirepAPI.post("/visitas/registrar_levantamiento_restriccion/"+nro_documento, values)
        return {data}
    } catch (error) {
        return {message:error}
    }
}
export const infoRestriction = async({commit},id) => {
    try {
        const {data} = await sirepAPI.get("/visitas/restriccion_por_id/"+ id)
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const updateRestriction = async({commit},arrayValue) => {
    const{id, form}=arrayValue;
    let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
    try {
        const {data} = await sirepAPI.put("/visitas/actualizar_restriccion/"+nro_documento+"/"+ id, form);
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const deleteRestriction = async({commit},id) => {
    let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
    try {
        const {data} = await sirepAPI.delete("/visitas/eliminar_restriccion/"+nro_documento+"/"+ id);
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const verifyRestriction = async({commit},val) => {
    const {id_visita, id_recinto}= val
    try {
        const {data} = await sirepAPI.get("/visitas/verificar_restriccion/"+id_visita+"/"+id_recinto);
        return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const registerOnlyVisit = async({commit}, value) => {
    try {
        let nro_documento = JSON.parse(localStorage.getItem('user')).nro_documento;
        const {data} = await sirepAPI.post("/visitas/registrar_solo_visitante/"+ nro_documento, value)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}







export const uploadFileRevocation = async({commit}, id) =>{
    const formData = new FormData();
        formData.append('uploaded_file', id[0]);
    try {
        var ext = id[0].name.split('.').pop();
                if(ext!=='pdf' && ext!=='PDF'){
                    alert("error")
                    return false
                  }
        //let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepApiFiles.post("/adicion_traslado_salidas/uploadFileRevocation/"+ id[1], formData)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const printResolutionRevocation = ({commit}, id) => {
    try {
        //const resp =  open("http://localhost:3012/adicion_traslado_salidas/view_file_revocation/"+id)
        const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/adicion_traslado_salidas/view_file_revocation/"+id)
        return resp
    } catch (error) {
        return {message:error}
    }
}
export const deleteFileRevocation = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/adicion_traslado_salidas/delete_file_revocation/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const receive_transfer = async({commit},datos) => {
    const{id_transfer, id_order, new_cod } = datos;
    try {
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepAPI.post("/adicion_traslado_salidas/recibir_transferencia" + "/" + userLogged + "/" + id_transfer + "/" +id_order+ "/" +new_cod)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const get_dataOrders_ppl = async({commit},info) => {
    try {
        const{cod_persona, tipo}=info
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/informacion_ordenes_judiciales" + "/" + cod_persona  + "/" + tipo)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const approve_liberty_ppl = async({commit},id_traslado_salida)=>{
    let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
    try {
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/aprobar_salida_definitiva"+"/" + userLogged + "/" +id_traslado_salida) 
        return {data} 
    } catch (error) {
        return {message:error}
    }    
};
export const deny_liberty_ppl = async({commit},data)=>{
    let{detalle, id_traslado_salida}=data
    let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
    try {
        const {data} = await sirepAPI.post("/adicion_traslado_salidas/negar_salida_definitiva"+"/" + userLogged + "/" +id_traslado_salida, { detalle }) 
        return {data} 
    } catch (error) {
        return {message:error}
    }    
};
export const turn_principal_order = async({commit},data)=>{
    let{id_orden_judicial,id_persona}=data
    try {
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/convertir_orden_principal"+"/" + id_orden_judicial + "/" +id_persona) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const print_add_transfer_departure = async({commit}, data) => {
    const{id, tipo}=data
    try {
        // const resp =  open("http://localhost:3012/adicion_traslado_salidas/view_add_transfer_departure/"+ id + "/" + tipo)
        // const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/adicion_traslado_salidas/view_add_transfer_departure/"+ id + "/" + tipo)
        // return resp
        const response =  await sirepAPI.get("/adicion_traslado_salidas/view_add_transfer_departure/"+ id + "/" + tipo,{
            responseType:'blob'
         })
        return response.data
    } catch (error) {
        return {message:error}
    }
}
export const repeal_order = async({commit},id)=>{
    try {
        const {data} = await sirepAPI.patch("/adicion_traslado_salidas/revocar_orden/"+id) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const register_order_departure = async({commit},ids)=>{
    try {
        const{id_traslado_salida, id_persona, id_orden}=ids
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepAPI.patch("/adicion_traslado_salidas/registrar_orden_salida_definitiva_sin_salida/" + id_persona + "/" + id_orden + "/" + id_traslado_salida + "/" + userLogged) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const get_types_of_deaths = async({ commit }, params)=>{
    try {
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/lista_tipos_decesos")
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }  
}
export const send_recapture = async({commit},datos)=>{
    const{id, fecha_recaptura, id_persona}=datos
    try {
        const {data} = await sirepAPI.put("/adicion_traslado_salidas/registrar_recaptura/"+ id +"/"+ id_persona, {fecha_recaptura}) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
